import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getRole } from '../Redux/selecters/index';
import { createHubConnection } from '../POS/services/signalRService';
import PlainLayout from '../POS/component/pages/SideBar/plainLayout';
// import Login from '../POS/component/pages/user/Login';
import Signup from '../POS/component/pages/user/signup';
import CustomerMenu from '../POS/Customer/Menu/customerMenu';
import AddtoCart from '../POS/Customer/Cart/cart';
import CardDetails from '../POS/Customer/Payment/cardDetails';
import WaitPage from '../POS/Customer/Payment/waitPage';
import CashierLayout from '../POS/Cashier/components/cashierLayout';
import MainLayout from '../POS/component/pages/SideBar/mainLayout';
import Orders from '../POS/component/pages/orders/order';
import OrderDragNDrop from '../POS/component/pages/orders/orderD&D';
import Menu from '../POS/component/pages/menus/menu';
import SingleOrder from '../POS/component/pages/orders/singleOrder/singleOrder';
import KitchenDisplay from '../POS/KDS/kitchenDisplay';
import CashierMenu from '../POS/Cashier/pages/cashierMenu';
import ThirdParty from '../POS/Customer/thirdParty/thirdParty';
import Costumer from '../POS/component/pages/AdminCustomer/customer';
import AddCostumer from '../POS/component/pages/AdminCustomer/AddCustomer';
import Employee from '../POS/component/pages/Employees/employee';
import CostumerDetails from '../POS/component/pages/AdminCustomer/customerDetail';
import AddEmployee from '../POS/component/pages/Employees/createEmployee';
import EmployeeDetails from '../POS/component/pages/Employees/employeeDetails';
import Restaurant from '../POS/component/pages/Restaurants/restaurant';
import CreateRestaurant from '../POS/component/pages/Restaurants/createRestaurant';
import ItemNavBar from '../POS/component/pages/menus/addItems/ItemNavBar';
import CreateBranch from '../POS/component/pages/Restaurants/createBranch';
import Dashboard from '../POS/component/pages/Dashboard/dashboard';
import OpeningCash from '../POS/Cashier/pages/openCash/openingCash';
import Dispute from '../POS/Cashier/pages/dispute';
import HandOverForm from '../POS/Cashier/components/handOverForm/handOverform';
import PayIn from '../POS/Cashier/pages/payIn';
import PayInForm from '../POS/Cashier/components/PayIn_out_Form/payInForm';
import PayOutForm from '../POS/Cashier/components/PayIn_out_Form/payOutForm';
import OpenCashList from '../POS/Cashier/pages/openCash/openCashList';
import HandOvered from '../POS/Cashier/components/handOverForm/handOverList';
import DayOpeningForm from '../POS/Cashier/components/DayOpening/dayOpeningForm';
import DayOpeningList from '../POS/Cashier/components/DayOpening/DayOpeningList';
import WaiterCall from '../POS/Cashier/components/waiterCall/waiterCall';
import SaleHistory from '../POS/Cashier/components/saleHistory/saleHistory';
import PayLater from '../POS/Cashier/components/saleHistory/payLater';
import UpdateOrder from '../POS/Cashier/components/updateOrder/updateOrder';
import PayOut from '../POS/Cashier/pages/payOut';
import AddCategory from '../POS/component/pages/master/addCategory';
import AddSubCategory from '../POS/component/pages/master/createSubCategory';
import AddVarients from '../POS/component/pages/master/variants';
import CreateModifier from '../POS/component/pages/menus/addItems/createModifiers';
import CreateAddOn from '../POS/component/pages/menus/addItems/createAddOn';
import AddCombos from '../POS/component/pages/menus/addItems/createCombo';
import UploadFile from '../POS/component/pages/master/uploadFile';
import AddCurrency from '../POS/component/pages/master/currencyManagment/currencyManagment';
import TaxManagment from '../POS/component/pages/master/taxManagment';
import AdminMaster from '../POS/component/pages/menus/addItems/createMenuItem';
import ItemDetails from '../POS/component/pages/menus/itemDetails/itemDetail';
import CashOrderDetail from '../POS/Cashier/components/saleHistory/cashOrderDetail';
import KDSLogin from '../POS/component/pages/user/kdsLogin';
import CardPayment from '../POS/Cashier/components/cashierPayment/cardPayment';
import TableMaster from '../POS/component/pages/master/tableMaster/tableMaster';
import Table from '../POS/Cashier/components/Table/table';
import KitchenHistory from '../POS/KDS/kitchenHistory';
import KitchenOrderDetail from '../POS/KDS/detail';
import KitchenMaster from '../POS/component/pages/master/kitchenMaster/kitchenMaster';
import Notification from '../POS/component/pages/setting/Notification';
import PasswordReset from '../POS/component/pages/setting/user';
import CurrencySetting from '../POS/component/pages/setting/currency';
import UserMaster from '../POS/component/pages/master/userMaster/userMaster';
import PaymentManagment from '../POS/component/pages/payment/paymentManagment';
import LandingPage from '../POS/LandingPage/landingPage';
import CurrencyDetail from '../POS/component/pages/master/currencyManagment/currencyDetail';
import Reports from '../POS/component/pages/reports/reports';
import DayCloseForm from '../POS/Cashier/components/DayClose/dayCloseForm';
import ReportGrid from '../POS/component/pages/reports/Grid/reportGrid';
import TotalOrder from '../POS/component/pages/reports/totalOrder';
import OrderHistory from '../POS/component/pages/reports/orderHistory';
import SaleReport from '../POS/component/pages/reports/saleReport/saleReport';
import SaleChart from '../POS/component/pages/reports/saleReport/saleChart';
import ThirdPartReport from '../POS/component/pages/reports/thirdPartReport/thirdPartReport';
import ThirdPartyGrid from '../POS/component/pages/reports/thirdPartReport/thirdPartyGrid';
import SaleDetail from '../POS/component/pages/reports/saleReport/saleDetail';
import DeliveryReport from '../POS/component/pages/reports/DeliveryReport';
import TaxReport from '../POS/component/pages/reports/taxReport';
import CashReport from '../POS/component/pages/reports/cashInReport';
import TableReport from '../POS/component/pages/reports/tableReport';
import CustomerCombo from '../POS/Customer/Combo/combo';
import NotFoundPage from '../POS/LandingPage/notFound/notFound';
import CreateMethod from '../POS/component/pages/master/paymentMethodMaster/createMethod';
import CreateDiscount from '../POS/component/pages/master/discountMaster/discountMaster';
import PromotionMaster from '../POS/component/pages/master/promotionMaster/promotionMaster';
import UserClaim from '../POS/component/pages/master/userRolesMaster/userClaim';
import UserRole from '../POS/component/pages/master/userRolesMaster/userRole';
import MainInventoryLayout from '../INVENTORY/Layouts/mainLayout';
import CreateItem from '../INVENTORY/Pages/itemMaster/createItems';
import UnitMeasurement from '../INVENTORY/Pages/measurementMaster/unitMeasurement';
import LocationMaster from '../INVENTORY/Pages/locationMaster/locationMaster';
import LocationCategoryMaster from '../INVENTORY/Pages/locationMaster/locationCategory';
import CategoryMaster from '../INVENTORY/Pages/categoryMaster/categoryMaster';
import SubCategoryMaster from '../INVENTORY/Pages/categoryMaster/subCategoryMaster';
import StockMaster from '../INVENTORY/Pages/stockMaster/stockMaster';
import PackingMaster from '../INVENTORY/Pages/packingMaster/packingMaster';
import DashBoard from '../INVENTORY/Pages/dashBoard/dashboard';
import Listing from '../INVENTORY/Pages/itemMaster/listing';
import PurchaseRequisition from '../INVENTORY/Pages/purchaseRequisition/purchaseRequisition';
import RequisitionListing from '../INVENTORY/Pages/purchaseRequisition/requisitionListing';
import Currency from '../INVENTORY/Pages/currencyMaster/currencyMaster';
import DocumentMaster from '../INVENTORY/Pages/documentMaster/departmentMaster';
import BranchMaster from '../INVENTORY/Pages/branchMaster/branchMaster';
import SupplierType from '../INVENTORY/Pages/supplierType/supplierType';
import PaymentMaster from '../INVENTORY/Pages/paymentMaster/paymentMaster';
import BankMaster from '../INVENTORY/Pages/bankMaster/bankMaster';
import GRNGrid from '../INVENTORY/Pages/Goods&Receipt/grnList/grnGrid';
import CreateGrn from '../INVENTORY/Pages/Goods&Receipt/grnList/createGrn';
import PriceComparisionGrid from '../INVENTORY/Pages/priceComparison/priceComparisonList';
import InvoiceList from '../INVENTORY/Pages/invoice/invoiceList';
import CreateInvoice from '../INVENTORY/Pages/invoice/invoiceCreate';
import PurchaseOrderGrid from '../INVENTORY/Pages/purchaseOrder/purchaseOrder';
import CreatePurchaseOrder from '../INVENTORY/Pages/purchaseOrder/createPurchaseOrder';
import DirectPurchaseKanooList from '../INVENTORY/Pages/directPurchaseKanoo/directPurchaseKanooList';
import CreateDirectPurchaseKanoo from '../INVENTORY/Pages/directPurchaseKanoo/createDirectPurchaseKanoo';
import PurchaseReturn from '../INVENTORY/Pages/purchaseReturn/purchaseReturn';
import ApprovalUser from '../INVENTORY/Pages/approvalUser/approvalUser';
import Approval from '../INVENTORY/Pages/approval/approval';
import StockTake from '../INVENTORY/Pages/stockTake/stockTake';
import Posting from '../INVENTORY/Pages/posting/posting';
import ItemIssueGrid from '../INVENTORY/Pages/issueItems/issueList';
import CreateIssue from '../INVENTORY/Pages/issueItems/createIssue';
import StockAdjustmentList from '../INVENTORY/Pages/stockAdjustment/stockAdjustmentList';
import CreateStockAdj from '../INVENTORY/Pages/stockAdjustment/createStockAdj';
import IssueInventory from '../INVENTORY/Pages/issueInventoryDirect/issueInventory';
import CreateIssueDirect from '../INVENTORY/Pages/issueInventoryDirect/createIssueDirect';
import IssueReturn from '../INVENTORY/Pages/IssueReturn/issueReturnList';
import CreateIssueReturn from '../INVENTORY/Pages/IssueReturn/createIssueReturn';
import IssueReceived from '../INVENTORY/Pages/IssueReceived/IssueReceivedList';
import CreateIssueReceived from '../INVENTORY/Pages/IssueReceived/createIssueReceived';
import DirectPurchaseList from '../INVENTORY/Pages/DirectPurchase/directPurchaseList';
import CreateDirectPurchase from '../INVENTORY/Pages/DirectPurchase/directPurchaseCreate';
import ItemReports from '../INVENTORY/Pages/reports/itemsReports';
import PurchaseOrderReports from '../INVENTORY/Pages/reports/poReports';
import PriceRequisitionReports from '../INVENTORY/Pages/reports/prReports';
import GrnReports from '../INVENTORY/Pages/reports/grnReports';
import PurchaseReturnReport from '../INVENTORY/Pages/reports/purchaseReturnReport';
import InvoiceReport from '../INVENTORY/Pages/reports/invoiceReports';
import PurchaseRequisitionView from '../INVENTORY/Pages/purchaseRequisition/viewpage/recositionView';
import PriceCompView from '../INVENTORY/Pages/priceComparison/comparisonView/comparisonView';
import CreatePurchaseReturn from '../INVENTORY/Pages/purchaseReturn/purchaseReturnCreate';
import UpdatePurchaseOrder from '../INVENTORY/Pages/purchaseOrder/updatePurchaseOrder';
import PurchaseOrderView from '../INVENTORY/Pages/purchaseOrder/view';
import GrnView from '../INVENTORY/Pages/Goods&Receipt/grnList/view';
import InvoiceView from '../INVENTORY/Pages/invoice/invoiceView';
import CompanyMaster from '../INVENTORY/Pages/companyMaster/company';
import UpdateGrn from '../INVENTORY/Pages/Goods&Receipt/grnList/updateGrn';
import UserStoreList from '../INVENTORY/Pages/userStore/userStoreList';
import UserStoreCreate from '../INVENTORY/Pages/userStore/userStoreCreate';
import StoreTransectionReport from '../INVENTORY/Pages/reports/storeTransectionReport';
import UpdateDirectPurchase from '../INVENTORY/Pages/DirectPurchase/updateDirectPurchase';
import IssueView from '../INVENTORY/Pages/issueItems/issueView';
import UpdateIssueDirect from '../INVENTORY/Pages/issueInventoryDirect/updateIssueDirect';
import UserStoreView from '../INVENTORY/Pages/userStore/userStoreView';
import StockAdjView from '../INVENTORY/Pages/stockAdjustment/stockView';
import StoreVarience from '../INVENTORY/Pages/reports/stockVarianceReport';
import { CurrencyProvider } from '../INVENTORY/Layouts/currencyContext';
import ApprovalListing from '../INVENTORY/Pages/approvalUser/approvalUserList';
import ApprovalUserView from '../INVENTORY/Pages/approvalUser/approvalUserView';
import PriceCompCreate from '../INVENTORY/Pages/priceComparison/priceCompCreate';
import EditApprovalUser from '../INVENTORY/Pages/approvalUser/editApprovalUser';
import IssueDirectView from '../INVENTORY/Pages/issueInventoryDirect/viewpage';
import IssueReturnView from '../INVENTORY/Pages/IssueReturn/viewPage';
import ItemMasterView from '../INVENTORY/Pages/itemMaster/itemView';
import EmailApproval from '../INVENTORY/Pages/approval/emailApproval';
import UpdateitemList from '../INVENTORY/Pages/itemMaster/updateItem';
import PurchaseRequisitionUpdate from '../INVENTORY/Pages/purchaseRequisition/updatePR';
import DirectPurchaseView from '../INVENTORY/Pages/DirectPurchase/directPurchaseView';
import PurchaseReturnView from '../INVENTORY/Pages/purchaseReturn/purchaseReturnView';
import EditIssue from '../INVENTORY/Pages/issueItems/editIssue';
import IssueReceivedView from '../INVENTORY/Pages/IssueReceived/issueReceiveView';
import EditIssueReceived from '../INVENTORY/Pages/IssueReceived/issueReceiveEdit';
import UpdatePurchaseReturn from '../INVENTORY/Pages/purchaseReturn/purchaseReturnUpdate';
import CostingReport from '../INVENTORY/Pages/reports/costingReport';
import CreatePurchaseOrderTwo from '../INVENTORY/Pages/purchaseOrder/purchaseOrder2/purchaseOrderT';
import PurchaseOrderGridK from '../INVENTORY/Pages/purchaseOrder/purchaseOrder2/PurchaseOrderK';
import CreateGrnK from '../INVENTORY/Pages/Goods&Receipt/grnList/grnKanoo/create';
import SupplierMasterListing from '../INVENTORY/Pages/supplierMaster/listing';
import SupplierCreate from '../INVENTORY/Pages/supplierMaster/create';
import UpdateSupplier from '../INVENTORY/Pages/supplierMaster/editSupplier';
import ViewSupplier from '../INVENTORY/Pages/supplierMaster/viewSupplier';

const AppRoutes = () => {
  return (
    <CurrencyProvider>
      <Routes>
        <Route
          path="/"
          element={
            <MainInventoryLayout>
              <DashBoard />
            </MainInventoryLayout>
          }
        />
        <Route path="/Inventory/DocumentAuthorization/:id/" element={<EmailApproval />} />
        <Route
          path="/Inventory/Dashboard"
          element={
            <MainInventoryLayout>
              <DashBoard />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Item/Create"
          element={
            <MainInventoryLayout>
              <CreateItem />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Item/:id"
          element={
            <MainInventoryLayout>
              <ItemMasterView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Item/Update/:id"
          element={
            <MainInventoryLayout>
              <UpdateitemList />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/UnitMeasurement"
          element={
            <MainInventoryLayout>
              <UnitMeasurement />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/inventory/Master/LocationMaster"
          element={
            <MainInventoryLayout>
              <LocationMaster />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Location/CategoryMaster"
          element={
            <MainInventoryLayout>
              <LocationCategoryMaster />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/category"
          element={
            <MainInventoryLayout>
              <CategoryMaster />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Company"
          element={
            <MainInventoryLayout>
              <CompanyMaster />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/SubCategory"
          element={
            <MainInventoryLayout>
              <SubCategoryMaster />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Stock"
          element={
            <MainInventoryLayout>
              <StockMaster />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Packing"
          element={
            <MainInventoryLayout>
              <PackingMaster />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Department"
          element={
            <MainInventoryLayout>
              <DocumentMaster />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Branch"
          element={
            <MainInventoryLayout>
              <BranchMaster />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Bank"
          element={
            <MainInventoryLayout>
              <BankMaster />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Supplier_Type"
          element={
            <MainInventoryLayout>
              <SupplierType />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Supplier/Listing"
          element={
            <MainInventoryLayout>
              <SupplierMasterListing />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Supplier/Create"
          element={
            <MainInventoryLayout>
              <SupplierCreate />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Supplier/Edit"
          element={
            <MainInventoryLayout>
              <UpdateSupplier />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Supplier/:id"
          element={
            <MainInventoryLayout>
              <ViewSupplier />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Payment"
          element={
            <MainInventoryLayout>
              <PaymentMaster />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/inventory/Master/Item"
          element={
            <MainInventoryLayout>
              <Listing />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Master/Currency"
          element={
            <MainInventoryLayout>
              <Currency />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Requisition/PurchaseRequisition"
          element={
            <MainInventoryLayout>
              <PurchaseRequisition />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Requisition/PurchaseRequisition/:id/:id"
          element={
            <MainInventoryLayout>
              <PurchaseRequisitionView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Requisition/Update/:id/:id"
          element={
            <MainInventoryLayout>
              <PurchaseRequisitionUpdate />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Requisition/Listing"
          element={
            <MainInventoryLayout>
              <RequisitionListing />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/GRN/Listing"
          element={
            <MainInventoryLayout>
              <GRNGrid />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/GRN/Listing/:id/:id"
          element={
            <MainInventoryLayout>
              <GrnView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/GRN/Create"
          element={
            <MainInventoryLayout>
              <CreateGrn />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/GRN/Create/K"
          element={
            <MainInventoryLayout>
              <CreateGrnK />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/GRN/Update/:id/:id"
          element={
            <MainInventoryLayout>
              <UpdateGrn />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/PriceComparison/List"
          element={
            <MainInventoryLayout>
              <PriceComparisionGrid />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/PriceComparison/price"
          element={
            <MainInventoryLayout>
              <PriceCompCreate />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/PriceComparison/View/:id/:id"
          element={
            <MainInventoryLayout>
              <PriceCompView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/invoice/List"
          element={
            <MainInventoryLayout>
              <InvoiceList />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/invoice/Create"
          element={
            <MainInventoryLayout>
              <CreateInvoice />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/invoice/:id/:id"
          element={
            <MainInventoryLayout>
              <InvoiceView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Purchase/Order"
          element={
            <MainInventoryLayout>
              <PurchaseOrderGrid />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Purchase/K"
          element={
            <MainInventoryLayout>
              <PurchaseOrderGridK />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/PurchaseOrder/:id/:id"
          element={
            <MainInventoryLayout>
              <PurchaseOrderView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/PurchaseOrder/Create/Two"
          element={
            <MainInventoryLayout>
              <CreatePurchaseOrderTwo />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Purchase/:id/:id"
          element={
            <MainInventoryLayout>
              <UpdatePurchaseOrder />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Purchase/Create"
          element={
            <MainInventoryLayout>
              <CreatePurchaseOrder />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/PurchaseReturn/List"
          element={
            <MainInventoryLayout>
              <PurchaseReturn />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/PurchaseReturn/Create"
          element={
            <MainInventoryLayout>
              <CreatePurchaseReturn />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/PurchaseReturn/Update"
          element={
            <MainInventoryLayout>
              <UpdatePurchaseReturn />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/PurchaseReturn/View/:id/:id"
          element={
            <MainInventoryLayout>
              <PurchaseReturnView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/ApprovalUser/List"
          element={
            <MainInventoryLayout>
              <ApprovalListing />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/ApprovalUser/Create"
          element={
            <MainInventoryLayout>
              <ApprovalUser />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/ApprovalUser/:id"
          element={
            <MainInventoryLayout>
              <EditApprovalUser />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Approval"
          element={
            <MainInventoryLayout>
              <Approval />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/ApprovalUser/:id/:id"
          element={
            <MainInventoryLayout>
              <ApprovalUserView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/StockTake"
          element={
            <MainInventoryLayout>
              <StockTake />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Posting"
          element={
            <MainInventoryLayout>
              <Posting />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/IssueItems/List"
          element={
            <MainInventoryLayout>
              <ItemIssueGrid />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/IssueItems/Create"
          element={
            <MainInventoryLayout>
              <CreateIssue />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/IssueItems/Update"
          element={
            <MainInventoryLayout>
              <EditIssue />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/IssueItems/:id/:id"
          element={
            <MainInventoryLayout>
              <IssueView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Stock/Adjustment"
          element={
            <MainInventoryLayout>
              <StockAdjustmentList />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Stock/Adjustment/create"
          element={
            <MainInventoryLayout>
              <CreateStockAdj />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Stock/Adjustment/:id/:id"
          element={
            <MainInventoryLayout>
              <StockAdjView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Issue/Direct"
          element={
            <MainInventoryLayout>
              <IssueInventory />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Issue/Direct/Create"
          element={
            <MainInventoryLayout>
              <CreateIssueDirect />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Issue/Direct/:id/:id"
          element={
            <MainInventoryLayout>
              <UpdateIssueDirect />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Issue/Direct/View/:id/:id"
          element={
            <MainInventoryLayout>
              <IssueDirectView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Issue/Return"
          element={
            <MainInventoryLayout>
              <IssueReturn />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Issue/Return/Create"
          element={
            <MainInventoryLayout>
              <CreateIssueReturn />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Issue/Return/:id/:id"
          element={
            <MainInventoryLayout>
              <IssueReturnView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Issue/Received"
          element={
            <MainInventoryLayout>
              <IssueReceived />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Issue/Received/:id/:id"
          element={
            <MainInventoryLayout>
              <IssueReceivedView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Issue/Received/Edit"
          element={
            <MainInventoryLayout>
              <EditIssueReceived />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Issue/Received/create"
          element={
            <MainInventoryLayout>
              <CreateIssueReceived />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/DirectPurchase/List"
          element={
            <MainInventoryLayout>
              <DirectPurchaseList />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/DirectPurchase/Create"
          element={
            <MainInventoryLayout>
              <CreateDirectPurchase />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/DirectPurchaseKanoo/List"
          element={
            <MainInventoryLayout>
              <DirectPurchaseKanooList />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/DirectPurchaseKanoo/Create"
          element={
            <MainInventoryLayout>
              <CreateDirectPurchaseKanoo />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/DirectPurchase/Update"
          element={
            <MainInventoryLayout>
              <UpdateDirectPurchase />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/DirectPurchase/:id/:id"
          element={
            <MainInventoryLayout>
              <DirectPurchaseView />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Reports/Items"
          element={
            <MainInventoryLayout>
              <ItemReports />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Reports/PurchaseOrder"
          element={
            <MainInventoryLayout>
              <PurchaseOrderReports />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Reports/PurchaseRequisition"
          element={
            <MainInventoryLayout>
              <PriceRequisitionReports />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Reports/grn"
          element={
            <MainInventoryLayout>
              <GrnReports />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Reports/PurchaseReturn"
          element={
            <MainInventoryLayout>
              <PurchaseReturnReport />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Reports/Invoice"
          element={
            <MainInventoryLayout>
              <InvoiceReport />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Reports/StockTransection"
          element={
            <MainInventoryLayout>
              <StoreTransectionReport />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Reports/stockVarience"
          element={
            <MainInventoryLayout>
              <StoreVarience />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/Reports/IssueCosting"
          element={
            <MainInventoryLayout>
              <CostingReport />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/UserStore/List"
          element={
            <MainInventoryLayout>
              <UserStoreList />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/UserStore/Create"
          element={
            <MainInventoryLayout>
              <UserStoreCreate />
            </MainInventoryLayout>
          }
        />
        <Route
          path="/Inventory/UserStore/:id/:id"
          element={
            <MainInventoryLayout>
              <UserStoreView />
            </MainInventoryLayout>
          }
        />
      </Routes>
    </CurrencyProvider>
  );
};

export default AppRoutes;
